export const canAccessGifts = role => ['admin', 'store_manager'].includes(role);

export const GIFTS_MENU_KEYS = [
  'giftsSettings', 'giftsCategories', 'giftsProducts', 'giftsDelivery', 'giftsRates',
  'giftsOrders', 'giftsStatistics', 'giftsEmailTemplates', 'giftsNotifications', 'giftsOutbox',
];
